import { cn } from '../../../../lib/utils';

export const getBubbleBaseStyles = () =>
  'relative w-fit text-sm leading-6 tracking-normal';

export const getBubbleRoleStyles = (role: 'user' | 'assistant') => {
  if (role === 'user') {
    return 'bg-primary text-primary-foreground rounded-xl rounded-tr-md ml-auto px-4 py-2';
  }
  return 'px-2 py-0';
};

export const getThinkingBubbleStyles = () =>
  cn(getBubbleBaseStyles(), getBubbleRoleStyles('assistant'));

export const getThinkingDotsStyles = () =>
  'flex items-center justify-center gap-1 py-2';
